<template>
  <div>

    <ValidationObserver v-slot="{ invalid }">
      <div class="d-flex toolbar justify-content-between mb-4">
        <h4 class="text-color-4">ตารางราคา</h4>

        <div class="flex">
          <Button type="button"
                  variant="primary"
                  custom_class="align-self-center mr-2"
                  @click="handleAddNewConfig">
            <i class="fas fa-plus-circle"></i>
          </Button>

          <Button type="button"
                  variant="success"
                  @click="handleFormSubmit"
                  custom_class="px-5 align-self-center mr-3"
                  :disabled="invalid || updateLoading || loading"
                  :loading="updateLoading">{{ $t("general.update") }}</Button>
        </div>


      </div>

      <div class="mt-5">
        <div v-if="loading">
          <Spinner size="sm" />
        </div>

        <div v-else
             v-for="(weightPricingConfig, i) in weightPricingConfigs"
             :key="i"
             class="mb-4">

          <!-- Toolbar -->
          <div class="d-flex mb-4">
            <button class="btn btn-link"
                    @click="() => weightPricingConfigs[i].visible = !weightPricingConfigs[i].visible">
              <i class="fas fa-chevron-down"
                 :class="{ 'fa-chevron-down': !weightPricingConfigs[i].visible, 'fa-chevron-up': weightPricingConfigs[i].visible }"></i>
            </button>

            <input type="text"
                   class="form-control mr-2"
                   :disabled="weightPricingConfig.name === 'ราคามาตรฐาน'"
                   v-model="weightPricingConfig.name">

            <button class="btn btn-link text-danger"
                    @click="handleRemoveConfig(i)"
                    v-if="weightPricingConfig.name !== 'ราคามาตรฐาน'"> <i class="fas fa-trash-alt"></i> </button>
          </div>

          <!-- config -->

          <div class="d-flex flex-column mb-4"
               v-if="weightPricingConfig.visible">
            <div class="d-flex"
                 v-for="(config, index) in weightPricingConfig.config"
                 :key="index">
              <div class="mx-5 align-self-center"></div>
              <NumberField id="price"
                           label="ราคา"
                           rules="required"
                           v-model="config.price" />
              <div class="mr-4 align-self-center"></div>
              <NumberField id="wMin"
                           label="น้ำหนักเริ่มต้น"
                           rules="required"
                           v-model="config.wMin" />
              <div class="mr-4 align-self-center"></div>
              <NumberField id="wMax"
                           label="น้ำหนักสูงสุด"
                           rules="required"
                           v-model="config.wMax" />

              <Button v-if="weightPricingConfig.name !== 'ราคามาตรฐาน'"
                      type="button"
                      variant="danger"
                      custom_class="ml-4 align-self-center text-white"
                      @click="handleRemove(weightPricingConfig.name, index)"> - </Button>
            </div>

            <div class="d-flex justify-content-end"
                 v-if="weightPricingConfig.name !== 'ราคามาตรฐาน'">
              <Button type="button"
                      variant="outline-primary"
                      custom_class="align-self-center mr-2"
                      @click="() => handleAdd(weightPricingConfig.name)">
                <i class="fas fa-plus-circle"></i>
              </Button>
              <div class="mx-4"></div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import Card from "@/components/core/Card";
import Spinner from "@/components/core/Spinner";
import { mapGetters } from "vuex";
import NumberField from "@/components/core/NumberField";
import Button from "@/components/core/Button";
import { defaultWeightPricing } from "../../../helpers/weightPricing"

export default {
  name: "SellerSettingsPricing",
  components: {
    Card,
    Spinner,
    NumberField,
    Button,
  },

  data() {
    return {
      loading: false,
      updateLoading: false,
      weightPricingConfigs:
        [
          { name: "ราคามาตรฐาน", config: [], visible: false }
        ]
    }
  },

  async created() {
    await this.fetchData();
  },

  methods: {

    async fetchData() {
      this.loading = true;
      const { status, data } = await this.$store.dispatch("settings/fetchSetting", { type: "pricing" });
      if (status) {
        if (data.weightPricing && data.weightPricing.length) {
          // old data
          if (!data.weightPricing[0].name) {
            this.weightPricingConfigs = [
              { name: "ราคามาตรฐาน", config: data.weightPricing, visible: true }
            ]
          } else if (data.weightPricing[0].name === "default") {
            data.weightPricing[0].name = "ราคามาตรฐาน"
            this.weightPricingConfigs = data.weightPricing
          }
          else this.weightPricingConfigs = data.weightPricing
        }
        else this.initPricingTable()
      }
      this.loading = false;
    },

    initPricingTable() {
      this.weightPricingConfigs[0].config = defaultWeightPricing();
    },

    handleAddNewConfig() {
      this.weightPricingConfigs.push({
        name: `new-${this.weightPricingConfigs.length}`, config: defaultWeightPricing(), visible: true
      })
    },

    handleRemoveConfig(index) {
      this.weightPricingConfigs.splice(index, 1)
    },

    handleAdd(name) {
      let index = this.weightPricingConfigs.findIndex(c => c.name === name)
      this.weightPricingConfigs[index].config.push({
        price: 0,
        wMin: 0,
        wMax: 0
      })
    },

    handleRemove(name, itemIndex) {
      let index = this.weightPricingConfigs.findIndex(c => c.name === name)
      this.weightPricingConfigs[index].config.splice(itemIndex, 1);
    },

    async handleFormSubmit() {
      this.updateLoading = true;
      const { status } = await this.$store.dispatch("settings/updateSetting", {
        type: "pricing",
        data: { weightPricing: this.weightPricingConfigs },
      });
      this.updateLoading = false;
    }
  }
};
</script>